/**
 * Sort talents by isRecommendedTalent (recommended first)
 * Used consistently across dropdown field, schedule block, and talent lists
 */
export const sortTalentsByRecommended = <T extends { isRecommendedTalent?: boolean }>(talents: T[]): T[] => {
  return [...talents].sort((a, b) => {
    if (a.isRecommendedTalent && !b.isRecommendedTalent) return -1;
    if (!a.isRecommendedTalent && b.isRecommendedTalent) return 1;
    return 0;
  });
};
